export default __webpack_public_path__ + "static/media/ltc.8f4aa9ce.png";